// src/SupplierList.js ver 00 Nov 23 10:53 pm - SB113
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './App';
import * as supplierService from './api/supplierService';
import PaginationBar2 from './PaginationBar2'; // Ensure this path is correct

function SupplierList() {
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const auth = useAuth();

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const TENANT_ID = auth.userProfile?.SubsCoDocId;

    useEffect(() => {
        const fetchSuppliers = async () => {
            if (!TENANT_ID) {
                setError("No associated company found. Please create one.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }
                const response = await supplierService.getSuppliers(token, TENANT_ID, currentPage, itemsPerPage);
                setSuppliers(response.suppliers);
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
            } catch (err) {
                console.error("Error fetching suppliers from Cloud Function: ", err);
                setError(`Failed to load suppliers: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchSuppliers();
    }, [auth, TENANT_ID, currentPage, itemsPerPage]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleLimitChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1);
    };

    if (loading) return <p>Loading suppliers...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!TENANT_ID) return <p style={{ color: 'orange' }}>Please create a company profile to manage suppliers.</p>;


    return (
        <div>
            <div className="page-header">
                <h2>Supplier List</h2>
                <Link to={`/suppliers/add`} className="btn secondary">Add New Supplier</Link>
            </div>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />

            <table>
                <thead>
                    <tr>
                        <th>Seq ID</th> {/* NEW */}
                        <th>Supplier Code</th> {/* NEW */}
                        <th>Company Name</th>
                        <th>Contact Person</th>
                        <th>Phone</th>
                        <th>Site Address</th> {/* NEW */}
                        <th>Official Email</th> {/* NEW */}
                        <th>Official Website</th> {/* NEW */}
                        <th>Date Added</th> {/* NEW */}
                        <th>Date Last Modified</th> {/* NEW */}
                    </tr>
                </thead>
                <tbody>
                    {suppliers.map(s => (
                        <tr key={s.id}>
                            <td>{s.SeqId}</td> {/* NEW */}
                            <td>{s.SupplierCode}</td> {/* NEW */}
                            <td>
                                <Link to={`/suppliers/edit/${s.id}`}>
                                    {s.companyName}
                                </Link>
                            </td>
                            <td>{s.contact}</td>
                            <td>{s.phone}</td>
                            <td>{s.SiteAddress}</td> {/* NEW */}
                            <td>{s.OfficialEmail}</td> {/* NEW */}
                            <td>{s.OfficialWebsite}</td> {/* NEW */}
                            <td>{s.DateAdded ? new Date(s.DateAdded._seconds * 1000).toLocaleString() : 'N/A'}</td> {/* NEW */}
                            <td>{s.DateLastModified ? new Date(s.DateLastModified._seconds * 1000).toLocaleString() : 'N/A'}</td> {/* NEW */}
                        </tr>
                    ))}
                </tbody>
            </table>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </div>
    );
}

export default SupplierList;